import { v as bvVar } from 'bv';

export default () => bvVar('locale');
